import { Button, Card, CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ValidatorForm } from 'react-material-ui-form-validator';
import Swal from 'sweetalert2';

import { UploadImage } from '../../../components';
import { getGlobalData, updOrgStucture } from '../../../redux/actions/GlobalActions';

const Manajemen = () => {
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({});
  const handleFormSubmit = () => {
    setSubmit(true);
    let data = {
      about_org_structure: params?.img,
      about_org_structure_ori: params?.about_org_structure_ori,
    };
    updOrgStucture(data)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = () => {
    setLoading(true);
    getGlobalData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            img_preview: data.about_org_structure,
            about_org_structure_ori: data.about_org_structure_ori,
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const handleChangeFoto = (file, path) => {
    setParams((pref) => ({
      ...pref,
      img: file,
      img_preview: path,
    }));
  };
  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Manajemen Perusahaan</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <UploadImage
                      uploadFoto={handleChangeFoto}
                      label="Unggah Foto Struktur Organisasi"
                      preview={params?.img_preview}
                      required={true}
                      aspectRatio={1440 / 1808}
                      note={[
                        "Format PNG, WEBP dan JPG diperbolehkan",
                        "*Ukuran foto 1440 x 1808",
                      ]}
                      maxHeight={1440}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="flex-end"
                      className="flex-column-reverse flex-md-row"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="text-white w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                        >
                          {submit ? (
                            <CircularProgress color="primary" size={25} />
                          ) : (
                            "Simpan"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default Manajemen;
